/* eslint-disable */
import { SVGProps } from "react";
const SvgEngineering = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="ruler (2)"
    xmlns="http://www.w3.org/2000/svg"
    width={18.461}
    height={18.462}
    fill="currentColor"
    viewBox="0 0 18.461 18.462"
    {...props}
  >
    <path
      data-name="Path 890"
      d="M4.325 9.808h2.163L4.325 8.182Z"
    />
    <path
      data-name="Path 891"
      d="M.865.109a.541.541 0 0 0-.867.432V4.4h1.084a.541.541 0 0 1 0 1.082H-.002v1.081h1.084a.541.541 0 0 1 0 1.082H-.002v1.081h1.084a.541.541 0 0 1 0 1.082H-.002v1.082h1.084a.541.541 0 0 1 0 1.082H-.002v1.623a.541.541 0 0 0 .541.541h2.7v-1.083a.541.541 0 0 1 1.082 0v1.082h1.088v-1.082a.541.541 0 1 1 1.082 0v1.082h1.081v-1.082a.541.541 0 0 1 1.082 0v1.082h1.082v-1.082a.541.541 0 1 1 1.082 0v1.082h1.08v-1.082a.541.541 0 0 1 1.082 0v1.082h4.94a.541.541 0 0 0 .324-.973ZM8.626 10.52a.54.54 0 0 1-.513.37H3.786a.541.541 0 0 1-.541-.541V7.1a.541.541 0 0 1 .865-.433l4.327 3.249a.54.54 0 0 1 .189.604Z"
    />
    <path
      data-name="Path 892"
      d="M2.161 15.757v2.163a.541.541 0 0 0 .541.541h1.623v-3.248H2.704a.541.541 0 0 0-.543.544Z"
    />
    <path
      data-name="Path 893"
      d="M5.407 15.213h7.572v3.245H5.407Z"
    />
    <path
      data-name="Path 894"
      d="m16.974 16.326-2.914-.956v2.943l2.911-.958a.541.541 0 0 0 0-1.026Z"
    />
  </svg>
);

export default SvgEngineering;
